var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsDateString, IsOptional, IsString, IsUrl } from 'class-validator';
import { MediaSummary } from '../../commons/medias/media';
import { IsAfterDateOrEqual } from '../../utils/validators/is-after';
import { IsBeforeOrToday } from '../../utils/validators/is-before-now';
/**
 * Affected endpoints
 * GET /manfredite/Certification
 * POST /manfredite/Certification/<id>
 * PUT /manfredite/Certification/<id>
 */
export class CertificationResponse {
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], CertificationResponse.prototype, "id", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], CertificationResponse.prototype, "title", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], CertificationResponse.prototype, "description", void 0);
__decorate([
    Expose(),
    IsDateString(),
    Type(() => Date),
    IsBeforeOrToday(),
    __metadata("design:type", Date)
], CertificationResponse.prototype, "dateFrom", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsDateString(),
    Type(() => Date),
    IsBeforeOrToday(),
    IsAfterDateOrEqual('from'),
    __metadata("design:type", Date)
], CertificationResponse.prototype, "dateTo", void 0);
__decorate([
    Expose(),
    IsArray({ each: true }),
    __metadata("design:type", Array)
], CertificationResponse.prototype, "technologies", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], CertificationResponse.prototype, "issuingOrganization", void 0);
__decorate([
    Expose(),
    IsOptional(),
    __metadata("design:type", MediaSummary)
], CertificationResponse.prototype, "logo", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    IsUrl({ require_protocol: true }),
    __metadata("design:type", String)
], CertificationResponse.prototype, "url", void 0);
//# sourceMappingURL=certification.response.js.map